import React, { Component } from 'react';
import { InputText } from 'primereact/inputtext';
import { connect } from 'react-redux';
import { Dropdown } from 'primereact/dropdown';
import { InputSwitch } from 'primereact/inputswitch';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { MultiSelect } from 'primereact/multiselect';
import Messages from '../../../shared/UI/Messages/Messages';
import axios from '../../../axios-url';


import { REDIRECT_TO_URL, HASACCESS } from '../../../shared/utility';
import { DROPDOWN_CONFIG, USER_SUBMENU_ID, Companyid } from '../../../shared/Config';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';
import * as actions from '../../../store/actions/index';

class AddOutletMaseter extends Component {
    state = {
        roles: [],
        type: 'add',
        isView: false,
        Id: null,
        UserId: null,
        EmployeeId: null,
        RoleId: null,
        functionalRoleId: [],
        functionalRoleOptions: [],
        approvalroles: [],
        approvalRoleId: null,
        UserId1: '',
        FirstName: '',
        MiddleName: '',
        LastName: '',
        EmailId: '',
        Password: '',
        MobileNumber: '',
        Activedirectory: false,
        Adloginid: '',
        Disablelogin: false,
        IsActive: false,
        createdBy: (this.props.loggedUserDetail.userName) ?? 'Admin',
        createdDate: new Date(),
        CompanyId: this.props.loggedUserDetail.CompanyId,
        touch: false,
        branchCode: '',
        branchName: '',
        latitude: '',
        longitude: '',
        geoLoading: false,
        BranchId:null
    }

    componentDidMount() {
        this.getAccess = HASACCESS(USER_SUBMENU_ID);
        const type = this.props.match.params.type;   // add / edit / view
        const id = this.props.match.params.id;

        this.setState({
            type: type,
            isView: type === 'view'
        });

        this.props.getMasterKeywordList('Role');
        this.props.getMasterKeywordList('Employee');
        this.props.getMasterKeywordList('ApprovalRole');

        axios.get('/master/api/DropDownValues/FRole')
            .then(response => {
                if (response.status === 200) {
                    let data = []
                    if (response.data && response.data.length > 0) {
                        data = response.data.map(list => {
                            let value = list.id;
                            let id = list.id;
                            let text = list.text
                            return { label: text, value: value.toString(), id: id };
                        })
                    }
                    this.setState({ functionalRoleOptions: data })
                }
            }
            )
            .catch(err => {
                this.growl.show({ severity: 'error', summary: null, detail: 'Functional Roles Api Failed' });
            })

        if (type !== 'add') {
            this.props.getMasterTableList(
                `res/GetbranchList?branchId=${id}`,
                this.props.loggedUserDetail.CompanyId
            );
        }
    }

    componentDidUpdate(prevProps) {

        if (
            this.props.tableLists &&
            this.props.tableLists !== prevProps.tableLists
        ) {
            const outlet = Array.isArray(this.props.tableLists)
                ? this.props.tableLists[0]
                : this.props.tableLists;

            if (outlet) {
                this.setState({
                    // Id: outlet.id || null,
                    BranchId: outlet.branchId || null,
                    branchCode: outlet.branchCode || '',
                    branchName: outlet.branchName || '',
                    latitude: outlet.latitude || '',
                    longitude: outlet.longitude || '',
                    IsActive: outlet.isActive || false
                });
            }
        }
    }


    change = (e) => {
        let { name, value } = e.target;
        this.setState({ [name]: value, touch: true })

    }

    getCurrentLocation = () => {
        if (!navigator.geolocation) {
            this.growl.show({ severity: 'error', summary: null, detail: 'Geolocation is not supported by your browser' });
            return;
        }

        this.setState({ geoLoading: true });

        navigator.geolocation.getCurrentPosition(
            (position) => {
                const { latitude, longitude } = position.coords;
                this.setState({
                    latitude: latitude.toString(),
                    longitude: longitude.toString(),
                    touch: true,
                    geoLoading: false
                });
            },
            (error) => {
                let detail = 'Unable to fetch location';
                switch (error.code) {
                    case error.PERMISSION_DENIED:
                        detail = 'Location access denied';
                        break;
                    case error.POSITION_UNAVAILABLE:
                        detail = 'Location information is unavailable';
                        break;
                    case error.TIMEOUT:
                        detail = 'Location request timed out';
                        break;
                    default:
                        detail = 'Unable to fetch location';
                }
                this.setState({ geoLoading: false });
                this.growl.show({ severity: 'error', summary: null, detail });
            },
            { enableHighAccuracy: true, timeout: 10000 }
        );
    }

    // add = () => {

    //     if (this.state.EmployeeId === null) {
    //         this.growl.show({ severity: 'error', summary: null, detail: 'Employee is required' });
    //         return;
    //     } else if (this.state.RoleId === null || this.state.RoleId === '') {
    //         this.growl.show({ severity: 'error', summary: null, detail: 'Role is required' });
    //         return;
    //     }

    //     else if (this.state.UserId1 === "") {
    //         this.growl.show({ severity: 'error', summary: null, detail: 'UserName is required' });
    //         return;
    //     } else if (this.state.FirstName === "") {
    //         this.growl.show({ severity: 'error', summary: null, detail: 'FirstName is required' });
    //         return;
    //     } else if (this.state.LastName === "") {
    //         this.growl.show({ severity: 'error', summary: null, detail: 'LastName is required' });
    //         return;
    //     } else if (this.state.EmailId === "" || this.state.EmailId === null) {
    //         this.growl.show({ severity: 'error', summary: null, detail: 'EmailId is required' });
    //         return;
    //     } else if (this.state.Password === "") {
    //         this.growl.show({ severity: 'error', summary: null, detail: 'Password is required' });
    //         return;
    //     } else if (this.state.MobileNumber === "" || this.state.MobileNumber === null) {
    //         this.growl.show({ severity: 'error', summary: null, detail: 'MobileNumber is required' });
    //         return;
    //     } else if (this.state.approvalRoleId === "" || this.state.approvalRoleId === null) {
    //         this.growl.show({ severity: 'error', summary: null, detail: 'Approval Roleid is required' });
    //         return;
    //     } else if (this.state.functionalRoleId === "" || this.state.functionalRoleId === null) {
    //         this.growl.show({ severity: 'error', summary: null, detail: 'functional Roleid is required' });
    //         return;
    //     }
    //     var data = {
    //         // EmployeeId: this.state.EmployeeId,
    //         // RoleId: null,
    //         // UserId1: this.state.UserId1,
    //         // FirstName: this.state.FirstName,
    //         // FunctionalRole: this.state.functionalRoleId.join(),
    //         // Approvalrole: this.state.approvalRoleId.join(),
    //         // MiddleName: this.state.MiddleName,
    //         // LastName: this.state.LastName,
    //         // EmailId: this.state.EmailId,
    //         // Password: this.state.Password,
    //         // MobileNumber: this.state.MobileNumber,
    //         // RoleAssigned: this.state.RoleId.join(),
    //         // Activedirectory: this.state.Activedirectory,
    //         // Adloginid: this.state.Adloginid,
    //         // Disablelogin: this.state.Disablelogin,
    //         // IsActive: this.state.IsActive,
    //         // CompanyId: this.state.CompanyId,
    //         // CreatedBy: this.state.createdBy,
    //         // CreatedDate: this.state.createdDate,
    //         
    //     }


    //     if (this.state.type === 'edit') {
    //         data.UserId = this.state.UserId;
    //         data.Id = this.state.Id
    //     }

    //     this.props.processDynamicData('user', this.state.type, data, 'res/GetbranchList');

    // }


    // add = (isedit) => {

    //     const type = isedit === true ? "edit" : "add";
    //     var data = [{
    //         branchCode: this.state.branchCode,
    //         branchName: this.state.branchName
    //     }]
    //     this.props.processDynamicData('ExchangeRate', type, data, 'res/GetbranchList?' + Companyid);

    // }

    add = () => {
        let type = this.props.match.params.type;

        // Validate required fields
        const errors = [];
        if (!this.state.branchCode || this.state.branchCode.trim() === '') {
            errors.push('Branch Code is required');
        }
        if (!this.state.branchName || this.state.branchName.trim() === '') {
            errors.push('Branch Name is required');
        }

        if (errors.length > 0) {
            errors.forEach(error => {
                this.growl.show({ severity: 'error', summary: 'Validation Error', detail: error });
            });
            return;
        }


        // const data = {
        //     branchId:this.state.BranchId,
        //     branchCode: this.state.branchCode.trim(),
        //     branchName: this.state.branchName.trim(),
        //     CompanyId: this.state.CompanyId,
        //     CreatedBy: this.state.createdBy,
        //     CreatedDate: this.state.createdDate,
        //     IsActive: this.state.IsActive || false,
        //     ...(type === 'edit' && this.state.Id && { Id: this.state.Id })
        // };

        // Log the data for debugging
       
        const data = {
        branchCode: this.state.branchCode.trim(),
        branchName: this.state.branchName.trim(),
        CompanyId: this.state.CompanyId,
        CreatedBy: this.state.createdBy,
        CreatedDate: this.state.createdDate,
        IsActive: this.state.IsActive || false
    };

    // Only send branchId for Edit
    if (type === 'edit') {
        data.branchId = this.props.match.params.id;
        data.Id = this.state.Id;
    }
        console.log('Submitting outlet data:', data);
        //  if (this.state.type === "edit") {
          
        //     data.branchId = this.props.match.params.id;   // based on your API
        // }

        this.props.processDynamicData('Branch', type, data, 'res/GetbranchList?' + Companyid);
    }

    // resetData = () => {
    //     var data = {
    //         UserId: null,
    //         EmployeeId: null,
    //         RoleId: null,
    //         functionalRoleId: null,
    //         approvalRoleId: null,
    //         UserId1: '',
    //         FirstName: '',
    //         MiddleName: '',
    //         LastName: '',
    //         EmailId: '',
    //         Password: '',
    //         MobileNumber: '',
    //         Activedirectory: false,
    //         Disablelogin: false,
    //         IsActive: false,
    //         type: 'add'
    //     }
    //     this.setState(data);
    // }

    resetData = () => {
        var data = {
            branchCode: '',
            branchName: '',
            Id: null,
            type: 'add',
            touch: false,
            // Keep these if they're still needed
            CompanyId: this.props.loggedUserDetail.CompanyId,
            createdBy: (this.props.loggedUserDetail.userName) ?? 'Admin',
            createdDate: new Date(),
            IsActive: false
        }
        this.setState(data);
    }

    render() {
        if (this.props.success) {
            REDIRECT_TO_URL('/outlet-master/', this.props);
        }


        let addAccess = true;
        let editAccess = true;
        if (this.getAccess !== undefined) {
            if (this.getAccess.viewAccess === false && this.props.userDetail.userId !== this.props.match.params.id) { this.props.history.push('/dashboard') }
            addAccess = (this.getAccess.addAccess === true) ? true : false;
            editAccess = (this.getAccess.editAccess === true) ? true : false;
        }
        let accessButton = { addAccess: addAccess, editAccess: editAccess }

        let roleOptions = [];
        if (this.props.Role && this.props.Role.length > 0) {
            roleOptions = this.props.Role;
        }
        let approvalroleOptions = [];
        if (this.props.ApprovalRole && this.props.ApprovalRole.length > 0) {
            approvalroleOptions = this.props.ApprovalRole;
        }

        let isEnabled = (this.state.touch === true);

        let redirectURL = '/users/';
        if (this.props.userDetail && this.props.match.params.id !== undefined) {
            if (this.props.userDetail.userId === this.props.match.params.id) {
                redirectURL = "/dashboard";
            }
        }


        return (
            <div className="p-grid">
                {this.props.loading || this.state.geoLoading && <div className="page-loader"></div>}
                {this.props.error !== null && <Messages type="error" message={this.props.error} />}
                {this.props.success !== null && <Messages type="success" message={this.props.success} />}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{ position: 'relative' }}>
                        <h1>{this.state.type} Outlet</h1>

                        <div className="p-grid mt1">

                            <div className="p-col-6 p-offset-3">
                                {/* <div className="p-col-12">
                                    <label htmlFor="acSimple">Restaurant/Kitchen <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <Dropdown className="p-col-12" placeholder="Select Restaurant/Kitchen" options={this.props.GetEmployeedropdown} value={this.state.EmployeeId} name="EmployeeId" onChange={this.change} {...DROPDOWN_CONFIG} />
                                </div> */}

                                {/* <div className="p-col-6 p-offset-3"> */}
                                {/* <div className="p-col-12">
                                        <label htmlFor="acSimple">Type <span className="requiredColor">*</span></label>
                                    </div>
                                    <div className="p-col-12 ">
                                        <Dropdown className="p-col-12" placeholder="Select Type" options={this.props.GetEmployeedropdown} value={this.state.EmployeeId} name="EmployeeId" onChange={this.change} {...DROPDOWN_CONFIG} />
                                    </div> */}


                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Branch Code <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="branchCode" placeholder="Branch Code" value={this.state.branchCode} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div>
                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Branch Name <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="branchName" placeholder="Branch Code" value={this.state.branchName} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div>

                                 <div className="p-col-12">
                                    <label htmlFor="acSimple">Latitude <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="latitude" placeholder="Latitude" value={this.state.latitude} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div>

                                 <div className="p-col-12">
                                    <label htmlFor="acSimple">Longitude <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="longitude" placeholder="Longitude" value={this.state.longitude} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div>

                                <div className="p-col-12 ">
                                    <Button
                                        type="button"
                                        label={this.state.geoLoading ? 'Fetching Location...' : 'Get Current Location'}
                                        icon="pi pi-map-marker"
                                        onClick={this.getCurrentLocation}
                                        disabled={!navigator.geolocation || this.state.geoLoading || this.state.type === 'view'}
                                    />
                                </div>
                                {/* <div className="p-col-12">
                                    <label htmlFor="acSimple">State <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="UserId1" placeholder="Select State" value={this.state.UserId1} onChange={this.change} />
                                </div> */}


                                {/* <div className="p-col-12">
                                    <label htmlFor="acSimple">City <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="FirstName" placeholder="Select City" value={this.state.FirstName} onChange={this.change} />
                                </div> */}

                                {/* <div className="p-col-6 p-offset-3"> */}
                                {/* <div className="p-col-12">
                                        <label htmlFor="acSimple">Outlet Type <span className="requiredColor">*</span></label>
                                    </div>
                                    <div className="p-col-12 ">
                                        <Dropdown className="p-col-12" placeholder="Select Outlet Type" options={this.props.GetEmployeedropdown} value={this.state.EmployeeId} name="EmployeeId" onChange={this.change} {...DROPDOWN_CONFIG} />
                                    </div> */}
                                {/* </div> */}

                                {/* <div className="p-col-12">
                                    <label htmlFor="acSimple">Status :</label>
                                </div>
                                <div className="p-col-12">
                                    <InputSwitch checked={this.state.IsActive} onChange={this.change} name="IsActive" value={this.state.IsActive} />
                                </div> */}
                            </div>
                            <div className="p-col-12 p-lg-12">

                                <FooterButton access={accessButton} disabled={!isEnabled || this.state.type === 'view'} type={this.state.type.toLowerCase()} save={this.add} reset={this.resetData} to="/outlet-master/" />

                            </div>

                        </div>

                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        loggedUserDetail: state.auth.userObject,
        userDetail: state.auth.userDetail,
        userPref: state.auth.userPref,
        GetEmployeedropdown: (state.keyword.Employee !== undefined) ? state.keyword.Employee : [],
        loading: state.master.loading,
        error: state.master.error,
        success: state.master.success,
        Role: (state.keyword.Role !== undefined) ? state.keyword.Role : [],
        ApprovalRole: (state.keyword.ApprovalRole !== undefined) ? state.keyword.ApprovalRole : [],
        tableLists: state.master.tableLists
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getMasterTableList: (table, companyid) => dispatch(actions.getMasterTableList(table, companyid)),
        getMasterKeywordList: (value) => dispatch(actions.getMasterKeywordList(value)),
        fetchRelavantLists: (value) => dispatch(actions.fetchRelavantLists(value)),
        processDynamicData: (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddOutletMaseter);